import React from "react";

import useMetricsContext from "src/organization/pages/project/environment/metrics/hooks/useMetricsContext";

import Threshold from "./Thresholds";
import VerticalAxis from "./VerticalAxis";

const Thresholds = props => {
  const metricsContext = useMetricsContext();
  return metricsContext?.enableThreshold ? (
    <Threshold {...props} />
  ) : (
    <VerticalAxis {...props} />
  );
};

export default React.memo(Thresholds);
